import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=3c22cc35&scoped=true&"
import script from "./ErrorComponent.vue?vue&type=script&lang=ts&"
export * from "./ErrorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22cc35",
  null
  
)

export default component.exports